import { ReactNode } from "react";
import { Card } from "@cofano/cck";
import { Skeleton, Typography, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

// eslint-disable-next-line react-refresh/only-export-components
export enum Height {
	Auto = "AUTO",
	Small = "SMALL",
	Medium = "MEDIUM",
	Large = "LARGE",
	Fill = "FILL"
 }

export const CreateBlock = ({ height, onClick, title }: { height: Height, onClick: () => void, title: string }) => {

	const theme = useTheme();

	return (
		<div
			className={`create-block ${height}`}
			onClick={() => onClick()}
			style={{ border: `2px dashed ${theme.palette.mode === "dark" ? "#fff" : "rgba(0, 0, 0, 0.295)"}` }}>
			<AddIcon color="action" />

			<Typography variant="h3" sx={{ fontSize: 28 }} color="textPrimary">
				{title}
			</Typography>
		</div>
	);
};

export const DetailsBlock = ({ height, children }: { height: Height, children: ReactNode }) => {
	return (
		<div className={`details-block ${height}`}>
			{children}
		</div>
	);
};

export const LoadingBlock = ({ height }: { height: Height }) => {
	return (
		<div className={`loading-block ${height}`}>
			<Card
				title={(
					<Skeleton
						variant="text"
						width={300}
						height={20} />
				)}
				actions={[ {
					render: () => (
						<Skeleton
							variant="text"
							width={28}
							height={20} />
					),
				}, {
					render: () => (
						<Skeleton
							variant="text"
							width={28}
							height={20}
							style={{ marginLeft: 12 }} />
					),
				} ]}>
				<div style={{ overflow: "hidden", height: "100%" }}>
					{Array.from(Array(height === Height.Auto ? 5 : 30).keys()).map((index) => (
						<Skeleton variant="text" height={20} key={index} />
					))}
				</div>
			</Card>
		</div>
	);
};
